__turbopack_context__.v({
  "product-carousel": "product-carousel-component-module-scss-module__UAlvaW__product-carousel",
  "product-carousel__tile": "product-carousel-component-module-scss-module__UAlvaW__product-carousel__tile",
});
